(function() {

  var accordion = $('.js-accordion');
  var btnCloseAlert = $('.js-btn-close-alert');

  accordion.click(function(){
    $(this).toggleClass('is-open');
    $(".js-accordion").not(this).removeClass('is-open');
  });

})(jQuery);